import styled from "styled-components";

export default styled.div`
  position: relative;
  height: 100%;

  .dropdwon-menu-action {
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    align-self: stretch;
    height: 100%;

    .point-container {
      display: flex;
      gap: 0.2rem;
      align-items: center;
      justify-content: center;
      padding: 0.2rem;

      .point {
        width: 5px;
        height: 5px;
        border-radius: 100%;
        background-color: gray;
      }
    }
  }
`;
